import Axios from "axios";

export default class Api {
  backendUrl = process.env.REACT_APP_BACKEND_URL;
  constructor(token, domain) {
    this.jwt = token;
    this.domain = domain;
  }
  getAuthUrl() {
    return this.backendUrl + "/auth/google/login";
  }
  async getQuestions() {
    try {
      const resp = await Axios({
        method: "get",
        url: this.backendUrl + `/questions/${this.domain}`,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
      });
      return resp.data;
    } catch (err) {
      if (!err.response) {
        return "err";
      }
      if (err.response.status === 500 || err.response.status === 401) {
        return "err";
      }
      return err.response.data;
    }
  }
  async submitAnswers(answers) {
    try {
      const resp = await Axios({
        method: "post",
        url: this.backendUrl + `/answers/${this.domain}`,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        data: answers,
      });
      return resp.data;
    } catch (err) {
      if (!err.response) {
        return "err";
      }
      if (err.response.status === 500 || err.response.status === 401) {
        return "err";
      }
      return err.response.data;
    }
  }

  async getTreasureData() {
    try {
      const resp = await Axios({
        method: "get",
        url: this.backendUrl + `/treasure`,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
      });
      return resp.data;
    } catch (err) {
      if (!err.response) {
        return "err";
      }
      if (err.response.status === 500 || err.response.status === 401) {
        return "err";
      }
      return err.response.data;
    }
  }
}
